import * as tslib_1 from "tslib";
import React from 'react';
import Modal from 'sinoui-components/Modal';
import AppearTransition from '../containers/AppearTransition';
import PopLayout from './PopLayout';
import PopContentLayout from './PopContentLayout';
import { MdClose } from 'react-icons/md';
import Icon from 'sinoui-components/Icon';
export default function Pop(_a) {
    var children = _a.children, render = _a.render, popContentClassName = _a.popContentClassName, popContentStyle = _a.popContentStyle, open = _a.open, close = _a.close, popAction = _a.popAction, onStartPop = _a.onStartPop, zIndex = _a.zIndex, contentRef = _a.contentRef, showCloseIcon = _a.showCloseIcon, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, props = tslib_1.__rest(_a, ["children", "render", "popContentClassName", "popContentStyle", "open", "close", "popAction", "onStartPop", "zIndex", "contentRef", "showCloseIcon", "onMouseEnter", "onMouseLeave"]);
    var PopContainer = props.useModal ? Modal : React.Fragment;
    var popContainerProps = props.useModal
        ? {
            fixed: false,
            open: open,
            backdrop: false,
        }
        : {};
    return (React.createElement(PopLayout, tslib_1.__assign({}, props),
        React.cloneElement(React.Children.only(children), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
        }),
        React.createElement(PopContainer, tslib_1.__assign({}, popContainerProps),
            React.createElement(AppearTransition, { open: open, onEnter: onStartPop }, function (exited) { return (React.createElement(PopContentLayout, { className: popContentClassName, style: popContentStyle, zIndex: zIndex, innerRef: contentRef },
                React.createElement("div", null,
                    showCloseIcon && (React.createElement(Icon, { style: {
                            position: 'absolute',
                            top: 10,
                            right: 20,
                            transform: 'scale(0.8)',
                            cursor: 'pointer',
                        }, onClick: close },
                        React.createElement(MdClose, null))),
                    render({ close: close })))); }))));
}
//# sourceMappingURL=Pop.js.map